<template>
  <v-app>
    <!-- <SideBarPage /> -->
     <HeaderPage  v-if="$route.path !== '/' && $route.path !== '/forgotPassword'" />
   <router-view></router-view>
   <!-- <FooterPage v-if="$route.path !== '/' && $route.path !== '/forgotPassword'"/> -->
  </v-app>
</template>

<script>
import "./assets/style/fonts.css";
import "./assets/style/style.css";
// import SideBarPage from "./components/Common/SideBar.vue"
// import HelloWorld from './components/HelloWorld';
import HeaderPage from "./components/Common/HeaderPage.vue";
// import FooterPage from "./components/Common/FooterPage.vue";

export default {
  name: 'App',

  components: {
    HeaderPage,
    // FooterPage,
    // HelloWorld,
    // SideBarPage
  },

  data: () => ({
    //
  }),
};
</script>
